export enum StatusIconSize {
    SMALL,
    MEDIUM,
}
